import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Alert } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';

import Icon from '../../Icon';

import { notificationSuccess } from '../../../store/notificationReducer';

const notificationDefault = {
  isNotification: false,
  type: '',
  action: '',
  message: '',
};

const Notification = () => {
  const dispatch = useDispatch();
  const notificationData = useSelector(
    (state) => state.notification.notification_success
  );
  const [isNotification, setIsNotification] = useState(
    notificationData.isNotification
  );

  useEffect(() => {
    if (notificationData.isNotification) {
      setIsNotification(true);

      setTimeout(() => {
        setIsNotification(false);

        dispatch(notificationSuccess(notificationDefault));
      }, 3000);
    }
  }, [notificationData, dispatch]);

  let icon = null;
  switch (notificationData.type) {
    case 'success':
      icon = <Icon id="success-check" width={24} height={24} />;
      break;
    case 'error':
      icon = <ErrorIcon />;
      break;
    default:
      icon = null;
  }

  return (
    isNotification && (
      <Alert
        severity={notificationData.type}
        icon={icon}
        sx={{
          position: 'fixed',
          bottom: '25px',
          zIndex: 9999,
          maxWidth: '600px',
          transform: ' translate(50%, 0)',
        }}
      >
        {notificationData.message}
      </Alert>
    )
  );
};

export default Notification;
